module.exports = __webpack_public_path__ + "img/dy_down_two.76ea9f3b.png";